import type { TFunction } from 'i18next';

export const formatReconciliationAge = (
  t: TFunction<'cabinet'>,
  seconds: number | null | undefined,
): string => {
  if (seconds == null || !Number.isFinite(seconds)) return '—';
  if (seconds < 3600) {
    return t('reconciliation.age.minutes', { count: Math.max(1, Math.floor(seconds / 60)) });
  }
  if (seconds < 86400) {
    return t('reconciliation.age.hours', { count: Math.max(1, Math.floor(seconds / 3600)) });
  }
  return t('reconciliation.age.days', { count: Math.max(1, Math.floor(seconds / 86400)) });
};

export const caseTypeLabel = (t: TFunction<'cabinet'>, type: string): string =>
  t(`reconciliation.caseType.${type}`, { defaultValue: type });

export const decisionActionLabel = (t: TFunction<'cabinet'>, action: string): string =>
  t(`reconciliation.decisionAction.${action}`, { defaultValue: action });

export const runStatusLabel = (t: TFunction<'cabinet'>, status: string): string =>
  t(`reconciliation.runStatus.${status}`, { defaultValue: status });

export const completenessLabel = (t: TFunction<'cabinet'>, value: string): string =>
  t(`reconciliation.completeness.${value}`, { defaultValue: value });

export const caseStatusLabel = (t: TFunction<'cabinet'>, status: string): string =>
  t(`reconciliation.caseStatus.${status}`, { defaultValue: status });

export const suspenseStatusLabel = (t: TFunction<'cabinet'>, status: string): string =>
  t(`reconciliation.suspenseStatus.${status}`, { defaultValue: status });

export const suspenseTypeLabel = (t: TFunction<'cabinet'>, type: string): string =>
  t(`reconciliation.suspenseType.${type}`, { defaultValue: type });

export const costStateLabel = (t: TFunction<'cabinet'>, state: string): string =>
  t(`reconciliation.costState.${state}`, { defaultValue: state });

export const snapshotBalance = (values: Record<string, string | null | undefined>, key: string): string | null => {
  const raw = values[key];
  if (raw == null || raw === '') return null;
  return String(raw);
};

export const observedBalance = (values: Record<string, string | null | undefined>): string | null =>
  snapshotBalance(values, 'blockchainBalance') ?? snapshotBalance(values, 'providerBalance');
